class TableRuleDetailCell extends UITableViewCell
{

}